import { defineMessages } from 'react-intl';

export const messages: {
	required: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	required: {
		id: 'proforma-form-renderer.common.utils.validators.required',
		defaultMessage: '{fieldLabel} is required.',
		description: 'Validation message for required field with given label.',
	},
});
